import axios from 'axios';
import { loginParams } from '../common/query';
import router from '../router';

let baseURL;
if (process.env.VUE_APP_CURRENTMODE == 'production') {
    baseURL = 'https://edu.uniontech.com/college/app';
} else if (process.env.VUE_APP_CURRENTMODE == 'prev') {
    baseURL = 'https://precollege.uniontech.com/college/app';
} else if (process.env.VUE_APP_CURRENTMODE == 'test') {
    baseURL = 'http://college-dev.uniontech.com/college/app';
    // "http://test.pxb.uniontech.com/college/app"
} else {
    // 本地开发时使用
    baseURL = 'http://college-dev.uniontech.com/college/app';
    // baseURL = 'http://10.10.72.250:8888/college/app';
}
// 创建一个axios实例
let $axios = (axios as any).create({
    baseURL,
    timeout: 1000000,
});

$axios.interceptors.request.use(
    function(config: any) {
        return config;
    },
    function(error: any) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
$axios.interceptors.response.use(
    function(response: any) {
        if (response.data.code == 401) {
            // 状态为401表示token过期，需要重新登录！
            localStorage.removeItem('userinfo');
            localStorage.removeItem('token');
            router.push('/index');
        }
        return response;
    },
    function(error: any) {
        // 对响应错误做点什么
        var originalRequest = error.config;
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
            alert('请求数据失败');
        }
        return Promise.reject(error);
    }
);

export default $axios;
